import axios from 'axios';

let http = axios.create({
  baseURL: window.server.baseUrl,
  // withCredentials: true,
  //headers: {
  //'Content-Type': 'application/x-www-form-urlencoded;charset=utf-8',
  //'Authorization': accessToken //设置token 其中K名要和后端协调好
  //},
  transformRequest: [function (data) {
    let newData = '';
    for (let k in data) {
      if (data.hasOwnProperty(k) === true) {
        newData += encodeURIComponent(k) + '=' + encodeURIComponent(data[k]) + '&';
      }
    }
    return newData;
  }]
});

function apiAxios(method, url, params, response) {
  var storage=window.localStorage;
  var accessToken = storage["access_token"];
  console.log('accessToken'+accessToken);
  http({
    headers: {
      'Content-Type': 'application/x-www-form-urlencoded;charset=utf-8',
      'Authorization': accessToken //设置token 其中K名要和后端协调好
    },
    method: method,
    url: url,
    data: method === 'POST' || method === 'PUT' ? params : null,
    params: method === 'GET' || method === 'DELETE' ? params : null,
  }).then(function (res) {
    if (typeof (res.headers['authorization']) != "undefined") {//更新token
      storage["access_token"] = res.headers['authorization'];
    }

    if(res.status == 200 && (res.data.code == 5001 || res.data.code == 5002 || res.data.code == 5003)){
      alert("登录授权失效,请重新登录");
      if(process.env.NODE_ENV != 'development') {
        if (url.indexOf("/store/") != -1) {//进入门店的登录页面
          //window.location.href = "/#/store/login";
        } else if (url.indexOf("/main_store/") != -1) {//进入总店的登录页面
          //window.location.href = "/#/mainStore/login";
        } else if (url.indexOf("/super_admin/") != -1) {//进入总店的登录页面
          //window.location.href = "/#/superAdmin/login";
        }
      }
      return;
    }
    response(res);

  }).catch(function (err) {
    response(err);
    alert("登录授权失效,请重新登录");
    if(process.env.NODE_ENV != 'development') {
      if (url.indexOf("/store/") != -1) {//进入门店的登录页面
        //window.location.href = "/#/store/login";
      } else if (url.indexOf("/main_store/") != -1) {//进入总店的登录页面
        //window.location.href = "/#/mainStore/login";
      } else if (url.indexOf("/super_admin/") != -1) {//进入总店的登录页面
        //window.location.href = "/#/superAdmin/login";
      }
    }
    return;
  })
}

function getUrl(url){
  if(url.indexOf('?') == -1){
    url = url + '?' + 't='+ new Date().getTime();
  }else{
    url = url + '&'  + 't='+ new Date().getTime();
  }
  return url;
}
export default {

  get: function (url, params, response) {
    url = getUrl(url);
    return apiAxios('GET', url, params, response)
  },
  post: function (url, params, response) {
    url = getUrl(url);
    return apiAxios('POST', url, params, response)
  },
  put: function (url, params, response) {
    url = getUrl(url);
    return apiAxios('PUT', url, params, response)
  },
  delete: function (url, params, response) {
    url = getUrl(url);
    return apiAxios('DELETE', url, params, response)
  }
}



// WEBPACK FOOTER //
// ./src/api/index.js